module.exports = __webpack_public_path__ + "img/live1.706f9fee.jpg";